import * as A from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as c } from "../../utilities/transformations.js";
import { distort as _ } from "../../helpers/distort.js";
import { grain as w } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as C } from "../../utilities/uv.js";
const O = {
  name: "Vapor2",
  collection: "vapor",
  tags: ["wave", "gradient", "colorful"],
  props: {
    colorA: {
      type: String,
      default: "#F78E69",
      transform: c,
      description: "The first color of the vapor wave."
    },
    colorB: {
      type: String,
      default: "#F7EF99",
      transform: c,
      description: "The second color of the vapor wave."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: a,
      uv: m,
      time: l,
      sin: i,
      mix: e,
      abs: p,
      smoothstep: d,
      blendOverlay: f,
      color: r,
      float: n
    } = A, u = 0.1, F = 2, v = 1.1, t = _(m(), 0.1, 1, F), g = i(
      t.y.mul(1.5).mul(Math.PI).sub(l.mul(o.speed.uniform).mul(0.5))
    ).mul(0.2).add(0.5).sub(u), h = e(
      o.colorA.uniform,
      o.colorB.uniform,
      t.x
    ), b = p(t.y.sub(g)).mul(2), s = d(
      n(0.5),
      0,
      b.mul(n(0.5))
    ), { correctedUV: E } = C(), T = w(1)(E), y = h.mul(s).sub(T);
    return f(a(
      e(
        r("#FFFFFF"),
        y,
        s.mul(v)
      ),
      1
    ), r("#FFFFFF"));
  }
};
export {
  O as componentDefinition,
  O as default
};
